import { useSelector } from 'react-redux';
 
export const useSafeSelector = (selector: (state: any) => any, fallback?: any) => {
  try {
    return useSelector(selector) ?? fallback;
  } catch (error) {
    return {};
  }
};
